export { default as VictorySharedEvents } from "./victory-shared-events";